import React from "react";
import ReactDOM from "react-dom";
import { showErrorMessage } from "../../commons/show-error-message";
import HexModal from "../../../app/components/modals/HexModal";
import ShowDeleteUploadingEmployeesModal from "../../../app/components/modals/employee/show-delete-uploading-employees-modal";
import { logError, addContextLog } from "../../../infrastructure/log";
import { translate } from "../../../infrastructure/translate/localization";

function renderConfirmModal(message, employeesToDelete, state, page) {
  ReactDOM.render(
    <HexModal>
      <ShowDeleteUploadingEmployeesModal
        message={message}
        employees={employeesToDelete}
        state={state}
        page={page}
      />
    </HexModal>,
    document.getElementById("modal-container")
  );
}

export async function displayDeleteUploadingEmployeesModal(
  message,
  employeesToDelete,
  state,
  page
) {
  try {
    addContextLog(
      "info",
      "displayDeleteUploadingEmployeesModal",
      "display-screen",
      { message, employeesToDelete, state }
    );
    renderConfirmModal(message, employeesToDelete, state, page);
  } catch (e) {
    logError(
      e,
      `Error to displayDeleteUploadingEmployeesModal with msg ${message}`
    );
    showErrorMessage(translate("common-messages.basic-error-message"), true, e);
  }
}
